module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/event_booth-0cd34c6792c49fbf2d73862bb023e1b7.jpg";